export enum ProjectType {
  arcReview = "Architectural Review",
  maintenance = "Maintenance",
  violation = "Violation",
  homeowner = "Homeowner",
  property = "Property"
}

export const ProjectTypes = [
  "Architectural Review",
  "Maintenance",
  "Violation",
  "Homeowner",
  "Property"
]

export enum ProjectStatus {
  submitted = "Submitted", // 1
  inReview = "In Review", // 2
  rejected = "Rejected", // 3
  inProcess = "In Process", // 4
  inDispute = "In Dispute", // 5
  completed = "Completed", // 6
  corrected = "Corrected", // 7
  approved = "Approved", // 8
  denied = "Denied", // 9
  activated = "Activated", // 10
  residentResponse = "Resident Response" // 11
}

export const ProjectStatuses = [
  "Submitted",
  "In Review",
  "Rejected",
  "In Process",
  "In Dispute",
  "Completed",
  "Corrected",
  "Approved",
  "Denied",
  "Activated",
  "Resident Response"
]